import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import {LoginForm} from "../../containers/LoginForm/LoginForm";
import {LoginLayout} from "../../layouts/LoginLayout/LoginLayout";


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        width: theme.spacing(8),
        height: theme.spacing(8),
        backgroundColor: theme.palette.primary.main
    }
}))


export const LoginPage = () => {
    const classes = useStyles()


    return <LoginLayout>
                <Paper>
                    <div className={classes.paper}>
                        <Avatar className={classes.avatar}/>
                        <LoginForm/>
                    </div>
                </Paper>
            </LoginLayout>
}